export type ThemeMode = 'light' | 'dark' | 'system';

const STORAGE_KEY = 'color-dots-theme';

const CYCLE: ThemeMode[] = ['light', 'dark', 'system'];

export function getStoredTheme(): ThemeMode {
  const value = localStorage.getItem(STORAGE_KEY);
  if (value === 'light' || value === 'dark' || value === 'system') {
    return value;
  }
  return 'system';
}

export function applyTheme(mode: ThemeMode): void {
  document.documentElement.dataset.theme = mode;
  localStorage.setItem(STORAGE_KEY, mode);
  document.dispatchEvent(new CustomEvent('themechange'));
}

export function initTheme(): void {
  applyTheme(getStoredTheme());
}

export function cycleTheme(): ThemeMode {
  const current = getStoredTheme();
  const index = CYCLE.indexOf(current);
  const next = CYCLE[(index + 1) % CYCLE.length];
  applyTheme(next);
  return next;
}

export function isDarkTheme(): boolean {
  const mode = document.documentElement.dataset.theme as ThemeMode | undefined;
  if (mode === 'dark') return true;
  if (mode === 'light') return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export function themeLabel(mode: ThemeMode): string {
  switch (mode) {
    case 'light':
      return 'Светлая тема';
    case 'dark':
      return 'Тёмная тема';
    case 'system':
      return 'Системная тема';
  }
}

export function listenSystemThemeChange(onChange: () => void): () => void {
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const handler = () => {
    if (getStoredTheme() === 'system') onChange();
  };
  mq.addEventListener('change', handler);
  return () => mq.removeEventListener('change', handler);
}
